import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { useEffect, useState } from 'react'
import { getBroadcastContactsAction } from 'slices/broadcastContact'
import useSingleBroadcast from 'hooks/useSingleBroadcast'

const useBroadcastContacts = () => {
	const [fetched, setFetched] = useState(false)

	const { broadcast } = useSingleBroadcast()

	const reduxState = useAppSelector(state => state.broadcastContact)

	const dispatch = useAppDispatch()

	const { loading, process, page, query } = reduxState

	const refresh = () => {
		if (broadcast && broadcast._id) {
			setFetched(true)
			dispatch(
				getBroadcastContactsAction({
					id: broadcast._id,
					process,
				})
			)
		}
	}

	useEffect(() => {
		if (!loading) {
			refresh()
		}
	}, [fetched, broadcast?._id, process, page, query])

	return { ...reduxState, refresh }
}

export default useBroadcastContacts
